import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {AREA, CITY, LOCATION_TYPE, PIN_CODE, STATE, ZONE, SHIP_PIN_CODE, STATE_REGION, ALL_CITY} from "./type";

export const locationCity = () => async (dispatch) => {
    const res = await callWebService(callTypes.get, "", Config.locations.city);
    if (res) {
        const {data} = res;
        dispatch({type: CITY, payload: data.response.data});
        return true;
    }
};

export const locationZone = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.zone}${id}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: ZONE, payload: data.response.data});
        return true;
    }
};

export const locationArea = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.area}${id}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: AREA, payload: data.response.data});
        return true;
    }
};

export const locationState = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.state}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: STATE, payload: data.response.data});
        return true;
    }
};

export const locationType = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        Config.locations.locationType
    );
    if (res) {
        const {data} = res;
        dispatch({type: LOCATION_TYPE, payload: data.response.data});
        return true;
    }
};

export const locationPinCode = (pinNumber) => async (dispatch) => {
    dispatch({type: PIN_CODE, payload: null});
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.pinCode}${pinNumber}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: PIN_CODE, payload: data.response.data});
        return data.response.data;
    }
};

export const shipTolocationPinCode = (pinNumber) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.pinCode}${pinNumber}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: SHIP_PIN_CODE, payload: data.response.data});
        return true;
    }
};

export const stateAndRegion = (cityId) => async (dispatch) => {
    dispatch({type: STATE_REGION, payload: []});
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.stateAndRegion}?city_id=${cityId}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: STATE_REGION, payload: data.response.data});
        return true;
    }
};

export const allCity = () => async (dispatch) => {
    dispatch({type: STATE_REGION, payload: []});
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.locations.getAllCity}`
    );
    if (res) {
        const {data} = res;
        dispatch({type: ALL_CITY, payload: data.response.data});
        return true;
    }
};
